angular.module('rjmNg.directives').directive "doubleselect", [() ->
  restrict: "E"
  template: """
      <div>
        <div class="control-group multi-select span">
          <div class"row">
            <label class="span"><h4>{{availableTitle}}</h4></label><button class="btn btn-mini span addAll" ng-click="addAll()">Add All</button>
          </div>
          <input type="text" ng-model="availableSearch" placeholder="Search {{availableTitle}}"/>
          <select multiple="true" ng-model="available" ng-options="option.name for option in availableOptions | filter:{name: availableSearch} | orderBy:'name'" ng-click="selectColumn()"/>
        </div>
        <div class="control-group multi-select span">
          <div class="row">
            <label class="span"><h4>{{selectedTitle}}</h4></label><button class="btn btn-mini span removeAll" ng-click="removeAll()">Remove All</button>
          </div>
          <input type="text" ng-model="selectedSearch" placeholder="Search {{selectedTitle}}"/>
          <select multiple="true" ng-model="selected" ng-options="option.name for option in selectedOptions | filter:{name: selectedSearch} | orderBy:'name'" ng-click="unSelectColumn()"/>
        </div>
      </div>"""
  replace: true
  scope:
    availableOptions: "="
    selectedOptions: "="
    availableTitle: "="
    selectedTitle: "="
  link: (scope, elem, attrs) ->
    scope.availableSearch = ""
    scope.selectedSearch = ""
    scope.selectColumn = ->
      if not scope.available? or scope.available.length is 0 or not scope.available[0]?
        return
      if _(scope.selectedOptions).contains scope.available[0]
        return
      scope.selectedOptions.unshift scope.available[0]
      scope.availableOptions = _(scope.availableOptions).without scope.available[0]

    scope.unSelectColumn = ->
      if not scope.selected? or scope.selected.length is 0 or not scope.selected[0]?
        return
      if _(scope.availableOptions).contains scope.selected[0]
        return
      scope.availableOptions.unshift scope.selected[0]
      scope.selectedOptions = _(scope.selectedOptions).without scope.selected[0]

    scope.addAll = ->
      scope.selectedOptions = _(scope.availableOptions).union scope.selectedOptions
      scope.availableOptions = []

    scope.removeAll = ->
      scope.availableOptions = _(scope.selectedOptions).union scope.availableOptions
      scope.selectedOptions = []
]
